import Vue from 'vue';
import { AclInstaller, AclCreate, AclRule } from 'vue-acl';
import router from '@/router';

Vue.use(AclInstaller);

let initialRole = '*';

const userInfo = JSON.parse(localStorage.getItem('userInfo'));
if (userInfo && userInfo.permissions) initialRole = userInfo.permissions;

export default new AclCreate({
    initial  : initialRole,
    notfound : '/404',
    router,
    acceptLocalRules : true,
    globalRules: {
        fetchMenu: new AclRule('store_menus').generate(),
        fetchRole: new AclRule('store_roles').generate(),

        viewAccounts : new AclRule('browse_accounts').generate(),
        viewUsers: new AclRule('browse_users').generate(),
        viewDuplication: new AclRule('browse_duplication').generate(),
        viewUnder: new AclRule('browse_under').generate(),
        viewCheatIP: new AclRule('browse_cheat_ip').generate(),
        viewBlackIP: new AclRule('browse_black_ip').generate(),
        viewOtherSport: new AclRule('browse_other_sport').generate(),
        viewWinloss: new AclRule('browse_account_info').generate(),
        viewQuery: new AclRule('browse_bet_query').generate(),
        viewMemberDup: new AclRule('browse_member_dup').generate(),
        viewFindSapGia: new AclRule('browse_find_sap_gia').generate(),
    }
});
